import { css, cx } from '@emotion/css';
import anchorLogotipo from '../../../assets/anchor-brand/anchor-logotipo.svg';
import anchorSimbolo from '../../../assets/anchor-brand/anchor-simbolo.svg';
import React from 'react';

export interface LogoMarkProps extends Omit<React.HTMLAttributes<HTMLSpanElement>, 'children'> {}

const wrapper = css({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '1rem',
  height: '3rem',
  lineHeight: 0,
  userSelect: 'none',
});

const symbolStyle = css({
  display: 'block',
  height: '100%',
  width: 'auto',
});

const logotypeStyle = css({
  display: 'block',
  height: '80%',
  width: 'auto',
});

export const LogoMark = React.forwardRef<HTMLSpanElement, LogoMarkProps>(
  ({ className, style, 'aria-label': ariaLabel, ...rest }, ref) => {
    return (
      <span
        ref={ref}
        className={cx(wrapper, className)}
        style={style}
        aria-label={ariaLabel || 'Anchor Ingressos'}
        {...rest}
      >
        <img src={anchorSimbolo} alt="Anchor Ingressos símbolo" className={symbolStyle} />
        <img src={anchorLogotipo} alt="Anchor Ingressos logotipo" className={logotypeStyle} />
      </span>
    );
  }
);

LogoMark.displayName = 'LogoMark';

export default LogoMark;
